import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { fetchHome } from '../actions';
import Helmet from '../components/Helmet';
import config from '../../helpers/config';
import { Typography, Grid, Button } from '@material-ui/core';
import hash from '../../helpers/hash'
import useDeepCompareEffect from 'use-deep-compare-effect'

const useStyles = makeStyles((theme) => ({
    contentImg: props => ({
        height: 600,
        [theme.breakpoints.down('md')]: {
            height: 400,
        },
        [theme.breakpoints.down('sm')]: {
            height: '50vh',
        },
        [theme.breakpoints.down('xs')]: {
            height: '30vh',
        },

        position: 'relative',

        '& .img': {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            position: 'absolute'
        },
        '& .img-border': {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
            border: '3px solid rgba(255,255,255,0.5)',
            position: 'absolute',
        },
        '& .img-title': {
            position: 'absolute',
            textAlign: 'center',
            top: -30,
            left: 50,
            
            [theme.breakpoints.down('xs')]: {
                top: 'auto',
                left: 'auto',
                bottom: 0,
                right: 0
            },
    
            '& > div': {
                position: 'absolute',
                top: 10,
                left: 10,
                right: 10,
                bottom: 10,
                border: '1px solid white'
            },

            '& h2': {
                writingMode: "vertical-rl",
                textRrientation: "upright",
                padding: '25px 15px 15px 15px',
                backgroundColor: hash.walk('theme.primary' , props),
                fontWeight: 500,
                color: 'white',
                letterSpacing: '10px',

                [theme.breakpoints.down('xs')]: {
                    writingMode: "initial",
                    padding: "15px 15px 15px 25px"
                },
            }
        }
    }),
    contentGridContainer: {
    },
    contentDesc: props => ({
        textAlign: 'center',
        position: 'relative',
        minHeight: 250,
        padding: 20,
        
        
        [theme.breakpoints.down('sm')]: {
            padding: '150px 0',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '50px 20px',
        },

        '& .bg': {
            backgroundSize: '130px auto',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            position: 'absolute'
        },
        '& .h3': {
            borderTop: '3px solid black',
            borderBottom: '3px solid black',
            padding: '2px 0px',
            width: "50%",
            margin: "15px auto",
            '& h3': {
                borderTop: '1px solid black',
                borderBottom: '1px solid black',
            },
        },
        '& h4': {
            fontWeight: 500
        }
    }),

    '@keyframes cover-animation': {
        // first
        '0%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-1.jpg)`,
            backgroundPosition: '0% 50%',
        },
        '20%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-1.jpg)`,
            backgroundPosition: '0% 25%',
        },
        // second
        '25%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-2.jpg)`,
        },
        '45%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-2.jpg)`,
            backgroundPosition: '50% 25%',
            transform: 'scale(1)',
        },
        // third
        '50%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-3.jpg)`,
        },
        '70%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-3.jpg)`,
            backgroundPosition: '50% 25%',
            transform: 'scale(1.1)',
        },
        // fourth
        '75%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-4.jpg)`,
        },
        '100%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-4.jpg)`,
            backgroundPosition: '0% 25%',
            transform: 'scale(1)',
        },
    },

    '@keyframes cover-animation-xs': {
        // first
        '0%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-1.jpg)`,
            transform: 'scale(1.1)',
            backgroundPosition: '30% 50%',
        },
        '20%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-1.jpg)`,
            backgroundPosition: '30% 25%',
            transform: 'scale(1)',
        },
        // second
        '25%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-2.jpg)`,
        },
        '45%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-2.jpg)`,
            backgroundPosition: '50% 25%',
            transform: 'scale(1)',
        },
        // third
        '50%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-3.jpg)`,
        },
        '70%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-3.jpg)`,
            backgroundPosition: '50% 25%',
            transform: 'scale(1.1)',
        },
        // fourth
        '75%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-4.jpg)`,
        },
        '100%': {
            backgroundImage: `url(${config.S3Endpoint}/home/cover-4.jpg)`,
            backgroundPosition: '25% 25%',
            transform: 'scale(1)',
        },
    },

    cover: {
        height: 'calc(100vh - 75px)',
        width: '100vw',
        animationName: '$cover-animation',
        animationDuration: '20s',
        animationIterationCount: 'infinite',
        backgroundSize: '110%',
        backgroundRepeat: 'no-repeat',
        boxShadow: '0px 0px 1000000px inset rgba(0,0,0,1)',

        [theme.breakpoints.down('md')]: {
        },
        [theme.breakpoints.down('sm')]: {
            height: '70vh',
            backgroundSize: 'cover',
            animationName: '$cover-animation-xs',
        },
        [theme.breakpoints.down('xs')]: {
            height: '70vh',
            backgroundSize: 'cover',
            animationName: '$cover-animation-xs',
        },
    },

    coverContainer: {
        overflow: 'hidden',
        position: 'relative',
        '& img': {
            opacity: 0,
            display: 'none'
        },
        '& .title': {
            writingMode: "vertical-rl",
            textRrientation: "upright",
            position: 'absolute',
            right: '10%',
            top: '10%',
            '& h3' : {
                textShadow: '1px 1px 3px black',
                color: 'white'
            }
        }
    },

    banner: props => ({
        height: 750,
        width: '100%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: "relative",
        display: "table",
        [theme.breakpoints.down('xs')]: {
            height: '50vh',
        },

        '& .bg': {
            opacity: 0.5,
            zIndex: 0,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            position: 'absolute'
        },

        '& .bg-border': {
            opacity: 0.5,
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
            position: 'absolute',
            border: `3px solid ${hash.walk('theme.primary', props)}`
        },

        '& .h3': {
            height: "100%",
            verticalAlign: "middle",
            display: "table-cell",
            zIndex: 1,
            paddingRight: "40px",
            transform: "translateZ(0px)",
            textAlign: 'right',
            [theme.breakpoints.down('xs')]: {
                textAlign: 'center',
                padding: '0 20px',
            },
        }
    })
}));

const HomePage = (props) => {
    const theme = useTheme();
    const { home } = props;
    const classes = useStyles(home);

    useDeepCompareEffect(() => {
        if (!home.isLoaded) props.fetchHome();
    }, [home])

    if (!home.isLoaded) {
        return <div>Loading...</div>;
    }


    return (
        <div>
            <Helmet {...home} />
            <div className={classes.coverContainer}>
                <img src={`${config.S3Endpoint}/home/cover-1.jpg`} />
                <img src={`${config.S3Endpoint}/home/cover-2.jpg`} />
                <img src={`${config.S3Endpoint}/home/cover-3.jpg`} />
                <img src={`${config.S3Endpoint}/home/cover-4.jpg`} />
                <div className={classes.cover}></div>
                <div className="title">
                    {home.desc.map((d, i) => {
                        return (<Typography variant="h3" key={i} style={{fontWeight: i === 0 ? 500 : 400}}>
                            <span style={{fontWeight: `${i === 0 ? 700 : 500}`}}>{d}</span>
                        </Typography>)
                    })}
                </div>
            </div>
            <div>
                {home.items.map((d, i) => {
                    const direction = i % 2 === 0 ? 'row' : 'row-reverse';
                    return (
                        <Grid key={i} container direction={direction} alignItems="center" justify="center" className={classes.contentGridContainer}>
                            <Grid item xs={12} sm={12} md={5} lg={5} className={classes.contentDesc}>
                                <div className="bg" style={{backgroundImage: `url(${config.S3Endpoint}${d.bg})`}}></div>
                                <div className="h3">
                                    <Typography variant="h3"><b>{d.name}</b></Typography>
                                </div>
                                {d.desc.map((ddesc, di) => {
                                    return (<Typography variant="h4" key={di}>{ddesc}</Typography>)
                                })}
                            </Grid>
                            <Grid item xs={12} sm={12} md={7} lg={7} className={classes.contentImg}>
                                <div className="img" style={{backgroundImage: `url(${config.S3Endpoint}${d.imgUrl})`}}></div>
                                <div className="img-border"></div>
                                {/* <div className="img-title">
                                    <div></div>
                                    <Typography variant="h2">{d.slogan}</Typography>
                                </div> */}
                            </Grid>
                        </Grid>
                    )
                })}
            </div>
            <div className={classes.banner}>
                <div className="bg"  style={{backgroundImage: `url(${config.S3Endpoint}${hash.walk('banner.imgUrl', home)})`}} />
                <div className="bg-border" />
                <div className="h3">
                    {(hash.walk('banner.desc', home) || []).map((d, i) => {
                        return <Typography variant="h3" key={i} >{d}</Typography>
                    })}
                </div>
            </div>
        </div>
    );
}

function mapStateToProps({ home }) {
    return { home };
}

export default {
    loadData: ({ dispatch }) => dispatch(fetchHome()),
    component:  connect(mapStateToProps, { fetchHome }) (HomePage)
}



// WEBPACK FOOTER //
// ./src/client/pages/HomePage.js